import { Dialog } from '@mui/material';
import React from 'react';
import {
    ModalBody,
    ModalFooter,
    ModalHeader,
} from '@Components/ModalComponents';

interface IDeleteProjectDialogProps {
    isOpen: boolean;
    onClose: () => void;
    isDeleting: boolean;
    onDelete: () => void;
    projectName: string;
}

const DeleteProjectDialog = (props: IDeleteProjectDialogProps) => {
    const { isOpen, onClose, isDeleting, onDelete, projectName } = props;

    return (
        <Dialog id="delete-project-dialog" open={isOpen} onClose={onClose}>
            <ModalHeader
                id="delete-project-dialog-header"
                title={`Are you sure you want to delete ${projectName}?`}
                onCancel={onClose}
                isCancelDisabled={isDeleting}
            />
            <ModalBody />
            <ModalFooter
                id="delete-project-dialog-footer"
                onCancel={onClose}
                onSubmit={onDelete}
                isSubmitting={isDeleting}
                submitText="Delete project"
            />
        </Dialog>
    );
};

export default DeleteProjectDialog;
